export default "__VITE_ASSET__DFvPSFtn__"